import { useRef, useLayoutEffect, useEffect } from "react";

/**
 * Hook to register keyboard shortcuts (hotkeys) for the application
 * @param key - The keyboard key to listen for (e.g., "F1", "F2", "Escape")
 * @param callback - Function to execute when the key is pressed
 */
export const useHotkeys = (
  key: string,
  callback: (event: KeyboardEvent) => void
) => {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === key) {
        callbackRef.current(event);
      }
    };

    document.addEventListener("keydown", handler);

    return () => document.removeEventListener("keydown", handler);
  }, [key]);
};
